import { inject, Injectable } from '@angular/core';

import { useRolloutPlanStore } from '../../../+state/rollout/rollout-plan.store';
import { RolloutPlanRequestDto } from '../../../infrastructure/backends/rollout-plan.dto';

@Injectable({
  providedIn: 'root'
})
export class RolloutPlanSummaryService {
  private store = inject(useRolloutPlanStore);

  async loadRolloutPlan(body: RolloutPlanRequestDto, options: { refetchAllPlans: boolean }) {
    return await this.store.createRolloutPlan(body, options);
  }

  async updateRolloutPlan(
    rolloutPlanId: number,
    options: { refetchAllPlans?: boolean; metadata: RolloutPlanRequestDto }
  ) {
    return this.store.editRolloutPlan(rolloutPlanId, options);
  }
}
